/**
 * Join Thousands section: live counts + split-flap style digit updates.
 * Baseline: 2026-04-13T00:00:00.000Z — tests=6000 (24/day), workouts=200000 (1100/day).
 */
(function () {
  if (window.__jthLiveCountsInit) {
    return;
  }
  window.__jthLiveCountsInit = true;

  var MS_PER_DAY = 86400000;
  var ANCHOR_MS = Date.UTC(2026, 3, 13);
  var TESTS_START = 6000;
  var TESTS_PER_DAY = 24;
  var WORKOUTS_START = 200000;
  var WORKOUTS_PER_DAY = 1100;

  var TICK_MS = 1000;

  /** @type {WeakMap<Element, string>} */
  var lastFormattedByEl = new WeakMap();

  function formatCount(n) {
    return Math.floor(n).toLocaleString('en-US');
  }

  function extractDigits(str) {
    var out = [];
    for (var i = 0; i < str.length; i++) {
      var c = str[i];
      if (c >= '0' && c <= '9') out.push(c);
    }
    return out;
  }

  function readDisplayedDigits(el) {
    return (el.textContent || '').replace(/[^\d]/g, '');
  }

  function buildRowHTML(formatted) {
    var html = '<span class="jth-live-qty__row">';
    for (var i = 0; i < formatted.length; i++) {
      var c = formatted[i];
      if (c === ',') {
        html += '<span class="jth-live-qty__sep">' + c + '</span>';
      } else {
        html +=
          '<span class="jth-live-qty__digit"><span class="jth-live-qty__track"><span class="jth-live-qty__face">' +
          c +
          '</span></span></span>';
      }
    }
    html += '</span>';
    return html;
  }

  function getDigitCells(el) {
    var wrap = el.querySelector('.jth-live-qty');
    if (!wrap) {
      return [];
    }
    return wrap.querySelectorAll('.jth-live-qty__digit');
  }

  function prefersReducedMotion() {
    return (
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches
    );
  }

  var TRANSFORM_MS = 500;
  var FALLBACK_MS = TRANSFORM_MS + 250;

  function runTwoFaceSlide(track, faceOut, faceIn, onDone) {
    var finished = false;
    var ended = 0;

    function tryFinish() {
      if (finished) return;
      ended++;
      if (ended < 2) return;
      finished = true;
      window.clearTimeout(fallbackTimer);
      faceOut.removeEventListener('transitionend', onOneEnd);
      faceIn.removeEventListener('transitionend', onOneEnd);
      onDone();
    }

    function onOneEnd(e) {
      if (e.propertyName !== 'transform') return;
      e.stopPropagation();
      tryFinish();
    }

    void track.offsetHeight;

    faceOut.style.transition = 'none';
    faceIn.style.transition = 'none';
    faceOut.style.transform = 'translate3d(0, 0, 0)';
    faceIn.style.transform = 'translate3d(0, -100%, 0)';
    void track.offsetHeight;
    faceOut.style.transition = '';
    faceIn.style.transition = '';

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        faceOut.style.transform = 'translate3d(0, 100%, 0)';
        faceIn.style.transform = 'translate3d(0, 0, 0)';
      });
    });

    faceOut.addEventListener('transitionend', onOneEnd);
    faceIn.addEventListener('transitionend', onOneEnd);

    var fallbackTimer = window.setTimeout(function () {
      if (finished) return;
      finished = true;
      faceOut.removeEventListener('transitionend', onOneEnd);
      faceIn.removeEventListener('transitionend', onOneEnd);
      onDone();
    }, FALLBACK_MS);
  }

  function animateDigitFlip(cell, fromChar, toChar, done) {
    var track = cell.querySelector('.jth-live-qty__track');
    if (!track) {
      done();
      return;
    }

    track.innerHTML = '';
    track.style.transform = '';

    var faceOut = document.createElement('span');
    faceOut.className = 'jth-live-qty__face jth-live-qty__face--exit';
    faceOut.textContent = fromChar;

    var faceIn = document.createElement('span');
    faceIn.className = 'jth-live-qty__face jth-live-qty__face--enter';
    faceIn.textContent = toChar;

    track.appendChild(faceOut);
    track.appendChild(faceIn);

    runTwoFaceSlide(track, faceOut, faceIn, function () {
      track.innerHTML = '<span class="jth-live-qty__face">' + toChar + '</span>';
      done();
    });
  }

  function measureLiveQtySize(rowInnerHTML, contextEl) {
    var probe = document.createElement('div');
    probe.setAttribute('aria-hidden', 'true');
    probe.style.cssText =
      'position:absolute;left:-99999px;top:0;visibility:hidden;pointer-events:none;white-space:nowrap;';
    probe.innerHTML = '<span class="jth-live-qty">' + rowInnerHTML + '</span>';
    contextEl.appendChild(probe);
    var inner = probe.querySelector('.jth-live-qty');
    var w = inner.offsetWidth;
    var h = inner.offsetHeight;
    contextEl.removeChild(probe);
    return { w: w, h: h };
  }

  function animateFullRowFlip(el, prevStr, newStr, ariaLabel, done) {
    var exitHTML = buildRowHTML(prevStr);
    var enterHTML = buildRowHTML(newStr);
    var sExit = measureLiveQtySize(exitHTML, el);
    var sEnter = measureLiveQtySize(enterHTML, el);
    var tw = Math.max(sExit.w, sEnter.w);
    var th = Math.max(sExit.h, sEnter.h);

    var track = document.createElement('span');
    track.className = 'jth-live-qty__full-row-track';
    track.style.width = tw + 'px';
    track.style.height = th + 'px';

    var faceOut = document.createElement('span');
    faceOut.className = 'jth-live-qty__full-row-face jth-live-qty__full-row-face--exit';
    faceOut.innerHTML = exitHTML;

    var faceIn = document.createElement('span');
    faceIn.className = 'jth-live-qty__full-row-face jth-live-qty__full-row-face--enter';
    faceIn.innerHTML = enterHTML;

    track.appendChild(faceOut);
    track.appendChild(faceIn);

    el.innerHTML = '';
    var wrap = document.createElement('span');
    wrap.className = 'jth-live-qty jth-live-qty--full-row-anim';
    wrap.appendChild(track);
    el.appendChild(wrap);
    el.setAttribute('aria-label', ariaLabel);

    runTwoFaceSlide(track, faceOut, faceIn, function () {
      mountStatic(el, newStr, ariaLabel);
      done();
    });
  }

  function mountStatic(el, newStr, ariaLabel) {
    el.innerHTML = '<span class="jth-live-qty">' + buildRowHTML(newStr) + '</span>';
    el.setAttribute('aria-label', ariaLabel);
    lastFormattedByEl.set(el, newStr);
  }

  function updateElement(el, newStr, ariaLabel) {
    var prev = lastFormattedByEl.get(el);

    if (prev === newStr) return;

    if (el.getAttribute('data-jth-animating') === '1') return;

    if (prefersReducedMotion()) {
      mountStatic(el, newStr, ariaLabel);
      return;
    }

    if (prev == null) {
      mountStatic(el, newStr, ariaLabel);
      return;
    }

    var prevDigits = extractDigits(prev);
    var newDigits = extractDigits(newStr);
    var targetDigitsStr = newDigits.join('');
    var cells = getDigitCells(el);

    if (prevDigits.length !== newDigits.length) {
      el.setAttribute('data-jth-animating', '1');
      el.setAttribute('aria-label', ariaLabel);
      animateFullRowFlip(el, prev, newStr, ariaLabel, function () {
        el.removeAttribute('data-jth-animating');
      });
      return;
    }

    if (cells.length !== newDigits.length) {
      if (cells.length > 0 && readDisplayedDigits(el) === targetDigitsStr) {
        lastFormattedByEl.set(el, newStr);
        return;
      }
      mountStatic(el, newStr, ariaLabel);
      return;
    }

    var indices = [];
    for (var i = 0; i < newDigits.length; i++) {
      if (prevDigits[i] !== newDigits[i]) indices.push(i);
    }

    if (indices.length === 0) {
      lastFormattedByEl.set(el, newStr);
      return;
    }

    el.setAttribute('data-jth-animating', '1');
    el.setAttribute('aria-label', ariaLabel);

    var remaining = indices.length;
    function finishOne() {
      remaining--;
      if (remaining <= 0) {
        lastFormattedByEl.set(el, newStr);
        el.removeAttribute('data-jth-animating');
      }
    }

    for (var j = 0; j < indices.length; j++) {
      (function (idx) {
        animateDigitFlip(cells[idx], prevDigits[idx], newDigits[idx], finishOne);
      })(indices[j]);
    }
  }

  function tick() {
    var days = (Date.now() - ANCHOR_MS) / MS_PER_DAY;
    var testsStr = formatCount(TESTS_START + TESTS_PER_DAY * days);
    var workoutsStr = formatCount(WORKOUTS_START + WORKOUTS_PER_DAY * days);

    document.querySelectorAll('[data-jth-live-count="tests"]').forEach(function (el) {
      updateElement(el, testsStr, 'Threshold tests: ' + testsStr);
    });
    document.querySelectorAll('[data-jth-live-count="workouts"]').forEach(function (el) {
      updateElement(el, workoutsStr, 'Workouts with breathing data: ' + workoutsStr);
    });
  }

  function start() {
    document.querySelectorAll('[data-jth-live-count]').forEach(function (el) {
      el.classList.add('jth-live-qty-root');
    });
    tick();
    window.setInterval(tick, TICK_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
